/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { ActivityLog } from '../types';
import { uploadItemToFirestore } from '../utils/firebaseSync';
import { generateCorrelationId } from '../security/backendContracts';

/**
 * Audit Repository
 * Append-only immutable log repository with correlation IDs and server timestamping.
 */
export class AuditRepository {
  private static STORAGE_KEY = 'insumedic_activity_logs';

  static getLocalLogs(): ActivityLog[] {
    const raw = localStorage.getItem(this.STORAGE_KEY);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  static saveLocalLogs(logs: ActivityLog[]): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(logs));
  }

  static async recordLog(
    usuario: string,
    modulo: string,
    accion: string,
    detalles: string,
    companyId: string = 'company-insumedic',
    nombreEmpresa: string = 'COMERCIALIZADORA INSUMEDIC S.A.S',
    correlationId?: string
  ): Promise<ActivityLog> {
    const now = new Date();
    const corrId = correlationId || generateCorrelationId('LOG');
    
    const newLog: ActivityLog = {
      id: `log-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`,
      timestamp: now.toISOString(),
      usuario,
      modulo,
      accion,
      detalle: `[${corrId}] ${detalles}`,
      companyId,
      nombreEmpresa,
      ipAddress: '127.0.0.1'
    };

    const logs = this.getLocalLogs();
    logs.unshift(newLog);
    this.saveLocalLogs(logs.slice(0, 1000)); // Cap local storage safely

    // Send to append-only Firestore collection
    await uploadItemToFirestore<ActivityLog>('logs', newLog);
    return newLog;
  }
}
